
<template>
  <div>
    <div @click="expenseDialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      v-model="expenseDialog"
      scrollable
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="closeExpenseDialog"
    >
      <v-card>
        <v-toolbar dark color="primary" max-height="60">
          <v-btn icon dark @click="closeExpenseDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <expense-edit
            :singlePage="true"
            @select="select"
            @reload="reload"
            @closeDialog="closeExpenseDialog"
            :accountCode="accountCode"
            :expenseType="expenseType"
            :entity_id="entity_id"
            :expenseEdit_id="expenseEdit_id"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import ExpenseEdit from "@/views/expense/ExpenseEdit.vue";

@Component({
  name: "ExpenseCreate",
  components: {
    ExpenseEdit,
  },
  props: {
    showExpenseDialog: {
      default: false,
    },
    accountCode: {
      default: null,
    },
    expenseType: {
      default: null,
    },
    entity_id: {
      default: null,
    },
    expenseEdit_id: {
      default: null,
    },
    btn: {
      default: false,
    },
  },
})
export default class EntityCreate extends Vue {
  expenseDialog = false;

  @Watch("showExpenseDialog")
  onShowDialogChange(val) {
    this.expenseDialog = val;
  }

  closeExpenseDialog() {
    this.expenseDialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }

  reload() {
    this.$emit("reload", true);
  }
}
</script>
